import { render, staticRenderFns } from "./HolidayMaster.vue?vue&type=template&id=23d71364&"
import script from "./HolidayMaster.vue?vue&type=script&lang=js&"
export * from "./HolidayMaster.vue?vue&type=script&lang=js&"
import style0 from "./HolidayMaster.vue?vue&type=style&index=0&id=23d71364&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports